import ongsListComponent from './ongsList.component';
import ongCard from './ongCard/ongCard';

let ongsListModule = angular.module('solidarity.ongsList', [
  ongCard
])

  .component('ongsList', ongsListComponent)

  .name;

export default ongsListModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongsList.js